import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { useLink } from "@grandvisionhq/frk-routing";
import { useIntl } from "@grandvisionhq/state";
import { getProductTealiumDescription } from "../../../../../../../../../../utils/utils/get-product-tealium-description.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
const RxGlassesCTA = ({
  action,
  onClickWhenOrderable,
  buttonRef,
  className,
  handleConversionEvent,
  bookAppointmentRouteConfig
}) => {
  const { getLabel } = useIntl();
  const { product, activeVariant } = useProductData();
  const bookAppointmentLink = useLink(bookAppointmentRouteConfig ?? { route: "appointments.book" });
  const configuratorTealiumAttributes = {
    "data-element-id": "Prod_AddLens",
    "data-description": getProductTealiumDescription(product.name, activeVariant.sku)
  };
  const bookAppointmentTealiumProps = {
    "data-element-id": "Prod_FindInStore"
  };
  return action === "OPEN_CONFIGURATOR" ? (
    // Open Configurator button
    /* @__PURE__ */ React.createElement(
      Button,
      {
        caption: getLabel("products.actions.openConfigurator"),
        "data-t": "btn-open-configurator",
        onClick: onClickWhenOrderable,
        btnRef: buttonRef,
        className,
        ...configuratorTealiumAttributes
      }
    )
  ) : (
    // Book Appointment button
    /* @__PURE__ */ React.createElement(
      Button,
      {
        caption: getLabel("products.actions.bookAppointment"),
        "data-t": "btn-book-examination",
        href: bookAppointmentLink?.href,
        className,
        onClick: handleConversionEvent,
        ...bookAppointmentTealiumProps
      }
    )
  );
};
export {
  RxGlassesCTA
};
//# sourceMappingURL=RxGlassesCTA.js.map
